import styled from 'styled-components';
import PText from './PText';

const FooterStyles = styled.div`
  background-color: var(--deep-dark);
  .copyright {
    /* background-color: var(--deep-dark); */
    text-align: left;
    padding: 0.7rem 0;
  }
  @media only screen and (max-width: 768px) {
    .copyright {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
  return (
    <FooterStyles>
      <div className="copyright">
        <div className="container">
          <PText> © 2022 - civilized Ape Town</PText>
        </div>
      </div>
    </FooterStyles>
  );
}
